import { NAME_OF_PRODUCT_TYPES, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useFeatureFlags from './useFeatureFlags';


export const getAvgUnitCostFieldNameForCampaign = (campaign, feature_flag) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return feature_flag ? 'click_analytic_avg_cpc' : 'click_analytic_cpc'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return 'lead_analytic_avg_cpl'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return 'call_analytic_avg_cpc'
    }

    return null;
}


export const getSearchesFieldNameForCampaign = (campaign, feature_flag) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return feature_flag ? 'click_analytic_total_searches' : 'click_analytic_searches'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return feature_flag ? 'lead_analytic_total_searches' : 'lead_analytic_searches'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return feature_flag ? 'call_analytic_total_searches' : 'call_analytic_searches'
    }

    return null;
}

export const getQueriesFieldnameForCampaign = (campaign, feature_flag) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return feature_flag ? 'click_analytic_total_opportunities' : 'click_analytic_queries'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return 'lead_analytic_total_opportunities'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return feature_flag ? 'call_analytic_total_opportunities' : 'call_analytic_opportunities'
    }

    return null;
}

export const getImpressionsFieldNameForCampaign = (campaign) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return 'click_analytic_impressions'
    }

    return null;
}

export const getTotalCostFieldNameForCampaign = (campaign, feature_flag) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return feature_flag ? 'click_analytic_total_cost' : 'click_analytic_total_payout'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return 'lead_analytic_total_cost'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return 'call_analytic_total_cost'
    }

    return null;
}

export const getTotalUnitsFieldNameForCampaign = (campaign, feature_flag) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return feature_flag ? 'click_analytic_total_clicks' : 'click_analytic_clicks'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return 'lead_analytic_total_leads'
    }

    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return feature_flag ? 'call_analytic_total_accepted' : 'call_analytic_billable_calls'
    }

    return null;
}

const getAvgBidFieldNameForCampaign = (campaign) => {
    if ([NAME_OF_PRODUCT_TYPES.CLICKS, NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS, NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS].includes(campaign?.product_type?.name)) {
        return 'click_analytic_avg_bid'
    }
    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.LEADS) {
        return 'lead_analytic_avg_bid'
    }
    if (campaign?.product_type?.name === NAME_OF_PRODUCT_TYPES.CALLS) {
        return 'call_analytic_avg_bid'
    }
    return null;
}

const PROPERTIES_TO_PICK_FOR_STATS = [
    "id",
    "click_analytic_queries",
    "click_analytic_impressions",
    "click_analytic_searches",
    "click_analytic_clicks",
    "click_analytic_total_payout",
    "click_analytic_avg_position",
    "click_analytic_avg_bid",
    "click_analytic_ctr",
    "click_analytic_cpc",

    //Leads
    "lead_analytic_total_opportunities",
    "lead_analytic_total_leads",
    "lead_analytic_total_cost",
    "lead_analytic_avg_cpl",
    "lead_analytic_total_won",

    //Calls
    "call_analytic_opportunities",
    "call_analytic_billable_calls",
    "call_analytic_total_cost",
    "call_analytic_avg_cpc",

    //New Campaigns Stats

    //clicks
    "click_analytic_total_inventory",
    "click_analytic_total_opportunities",
    "click_analytic_total_searches",
    "click_analytic_impressions",
    "click_analytic_total_clicks",
    "click_analytic_total_cost",
    "click_analytic_avg_bid",
    "click_analytic_avg_cpc",
    "click_analytic_target_rate",
    "click_analytic_bid_rate",
    "click_analytic_epw",
    "click_analytic_win_rate",
    "click_analytic_success_rate",
    "click_analytic_prefill_success_rate",
    "form_submissions",
    "submission_rate",

    //leads
    "lead_analytic_total_inventory",
    "lead_analytic_total_opportunities",
    "lead_analytic_total_searches",
    "lead_analytic_total_selected",
    "lead_analytic_total_won",
    "lead_analytic_total_leads",
    "lead_analytic_total_cost",
    "lead_analytic_avg_bid",
    "lead_analytic_avg_cpl",
    "lead_analytic_target_rate",
    "lead_analytic_bid_rate",
    "lead_analytic_win_rate",
    "lead_analytic_success_rate",

    //calls
    "call_analytic_total_inventory",
    "call_analytic_total_opportunities",
    "call_analytic_total_searches",
    "call_analytic_total_calls",
    "call_analytic_billable_calls",
    "call_analytic_total_cost",
    "call_analytic_total_duration",
    "call_analytic_avg_bid",
    "call_analytic_avg_cpc",
    "call_analytic_target_rate",
    "call_analytic_bid_rate",
    "call_analytic_win_rate",
    "call_analytic_success_rate",
    "call_analytic_total_accepted",
    "call_analytic_avg_call_duration"
    //clicks
    //todo
]

const useCampaignsWithStats = () => {
    const {
        campaigns,
        click_campaign_stats,
        lead_campaign_stats,
        call_campaign_stats,
    } = useSelector(state => ({
        campaigns: state.Campaign.campaigns,
        click_campaign_stats: state.Campaign.click_campaign_stats,
        lead_campaign_stats: state.Campaign.lead_campaign_stats,
        call_campaign_stats: state.Campaign.call_campaign_stats,
    }))

    const [isFeatureFlagActive] = useFeatureFlags();
    const new_campaign_page_feature_flag_active = useMemo(() => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_NEW_CAMPAIGNS_PAGE_UI), [isFeatureFlagActive])

    const campaignsWithStats = useMemo(() => {
        return campaigns.map(campaign => {
            let campaign_stat = click_campaign_stats.find(cmp_stat => cmp_stat.id == campaign.id)
            switch (campaign.product_type.name) {
                case NAME_OF_PRODUCT_TYPES.CLICKS:
                case NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS:
                case NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS:
                    campaign_stat = click_campaign_stats.find(cmp_stat => cmp_stat.id == campaign.id)
                    break;
                case NAME_OF_PRODUCT_TYPES.LEADS:
                    campaign_stat = lead_campaign_stats.find(cmp_stat => cmp_stat.id == campaign.id)

                    break;
                case NAME_OF_PRODUCT_TYPES.CALLS:
                    campaign_stat = call_campaign_stats.find(cmp_stat => cmp_stat.id == campaign.id)

                    break;
            }

            if (!campaign_stat) {
                return campaign
            }

            let campaignWithStat = {
                ..._.cloneDeep(campaign),
                ..._.pick(campaign_stat, PROPERTIES_TO_PICK_FOR_STATS),
                'searches': campaign_stat[getSearchesFieldNameForCampaign(campaign, new_campaign_page_feature_flag_active)],
                'queries': campaign_stat[getQueriesFieldnameForCampaign(campaign, new_campaign_page_feature_flag_active)],
                'impressions': campaign_stat[getImpressionsFieldNameForCampaign(campaign)],
                'total_units': campaign_stat[getTotalUnitsFieldNameForCampaign(campaign, new_campaign_page_feature_flag_active)],
                'total_cost': campaign_stat[getTotalCostFieldNameForCampaign(campaign, new_campaign_page_feature_flag_active)],
                'avg_unit_cost': campaign_stat[getAvgUnitCostFieldNameForCampaign(campaign, new_campaign_page_feature_flag_active)],
                'avg_bid': campaign_stat[getAvgBidFieldNameForCampaign(campaign)],
            }

            if (campaign?.ad_groups && campaign_stat?.ad_groups) {
                campaignWithStat.ad_groups = campaign.ad_groups.map(
                    adg => ({ ...adg, ...(campaign_stat.ad_groups.find(adg_stat => adg_stat.id == adg.id) || {}) })
                )
            }

            if (campaign?.campaign_source_settings && campaign_stat?.campaign_source_settings) {
                campaignWithStat.campaign_source_settings = campaign.campaign_source_settings.map(
                    src => ({ ...src, ...(campaign_stat.campaign_source_settings.find(src_stat => src_stat.id == src.id) || {}) })
                )
            }
            return campaignWithStat;
        })
    }, [campaigns, click_campaign_stats, lead_campaign_stats, call_campaign_stats, new_campaign_page_feature_flag_active])

    return [campaignsWithStats];
}

export default useCampaignsWithStats;
